import { BankAccount } from "./enums";

export const bankAccountTypes = [
  BankAccount.CURRENT,
  BankAccount.JOINT,
  BankAccount.SAVING,
];
